import dayjs from 'dayjs';
import { useStore } from 'effector-react';
import { Button, FormField, TextInput, toaster } from 'evergreen-ui';
import React, { useState } from 'react';
import { history } from 'src/history';
import { routes } from 'src/routes';
import { group$, groupMemberFx } from 'src/store/group.store';
import { isUserActive$, user$ } from 'src/store/user.store';

export const GroupGuard = () => {
	const [key, updateKey] = useState('');
	const user = useStore(user$);
	const isUserActive = useStore(isUserActive$);
	const group = useStore(group$);
	const isExpired = dayjs(group?.distribution_date).isBefore(dayjs());

	const handleJoin = () => {
		if (!isUserActive) {
			const link = (
				<a
					href={routes.root.home.profile.path}
					style={{ textDecoration: 'underline', cursor: 'pointer', color: 'var(--blue500)' }}
					onClick={(e) => {
						e.preventDefault();
						history.push(routes.root.home.profile.path);
					}}
				>
					profile
				</a>
			);

			toaster.danger(<>To join you need to completely fill out the {link} and choose more than 5 interests</> as any);
			return;
		}

		groupMemberFx({
			type: 'add',
			user: user?.id,
			key: key.length > 0 ? key : undefined,
		});
	};

	return (
		<div
			style={{
				maxWidth: 500,
				marginLeft: 'auto',
				marginRight: 'auto',
			}}
		>
			{group?.private && <FormField
				label={'Enter key:'}
				style={{
					marginBottom: 16,
				}}
			>
				<TextInput
					value={key}
					width={'100%'}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateKey(e.target.value)}
				/>
			</FormField>}
			<Button
				disabled={group?.distributed || isExpired}
				appearance={'primary'}
				onClick={handleJoin}
				width={'80%'}
				height={'40px'}
				style={{
					margin: 'auto',
					marginTop: 40,
					marginBottom: 40,
					textAlign: 'center',
					display: 'flex',
					justifyContent: 'center',
					background: '#087587',
					color: '#fff',
					transition: 'all .4s',
					border: 'none',
					borderRadius: 30,
					padding: 12,
					fontSize: 16,
					outline: 'none',
					maxWidth: 300,
					fontFamily: 'Montserrat',
					fontWeight: 300,
				}}
			>
				Join
			</Button>
		</div>
	);
};
